import { render, staticRenderFns } from "./Increase.vue?vue&type=template&id=55d9b6fa&scoped=true&"
import script from "./Increase.vue?vue&type=script&lang=js&"
export * from "./Increase.vue?vue&type=script&lang=js&"
import style0 from "./Increase.vue?vue&type=style&index=0&id=55d9b6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9b6fa",
  null
  
)

export default component.exports